import React, { useContext } from 'react';
import classnames from 'classnames';
import { useTranslation } from 'react-i18next';
import { IconSize } from '@wix/da-ds/pkg/Icons/IconWrap';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import ThumbIconButton from '@wix/da-ds/pkg/thumbs/ThumbIconButton';
import TextButton from '@wix/da-ds/pkg/Buttons/TextButton';
import CommentOutlineIcon from '@wix/da-ds/pkg/Icons/24x24/CommentOutline';
import { BiData, BiContextProvidedValue, } from '@wix/da-bi/pkg/events';
import { getDeviationResourceType } from '../../../../_helpers';
import noop from '../../../../../utils/noop';
import { useSubscriptionTier } from '../../../../../utils/hooks/useSubscriptionTier';
import { useDeviationAttributes } from '../../../../hooks/useDeviationAttributes';
import SubscribeToUnlockTooltip from '../../../../../ActionBar/_partials/SubscribeToUnlockTooltip';
var CommentControl = function (_a) {
    var _b, _c, _d;
    var deviation = _a.deviation, className = _a.className, iconClassName = _a.iconClassName, textClassName = _a.textClassName, disabledClassName = _a.disabledClassName, _e = _a.onClick, onClick = _e === void 0 ? noop : _e;
    var t = useTranslation().t;
    var isMobile = useContext(MobileContext);
    var _f = useSubscriptionTier(deviation), isOwner = _f.isOwner, needsSubscription = _f.needsSubscription, isSubscribedButBlocked = _f.isSubscribedButBlocked;
    var isCommentable = useDeviationAttributes(deviation, isOwner).isCommentable;
    if (!isCommentable) {
        return null;
    }
    var biData = BiData({
        evid: 105,
        typeid: getDeviationResourceType(deviation),
        itemid: deviation.deviationId,
        creatorid: (_c = (_b = deviation.author) === null || _b === void 0 ? void 0 : _b.useridUuid) !== null && _c !== void 0 ? _c : '',
        sectionname: BiContextProvidedValue,
        sectionid: BiContextProvidedValue,
        section_typeid: BiContextProvidedValue,
        sectiontype: BiContextProvidedValue,
        sectionrank: BiContextProvidedValue,
        rank: BiContextProvidedValue,
        sort_type: BiContextProvidedValue,
        reason_shown: BiContextProvidedValue,
        widgetname: BiContextProvidedValue,
    });
    var actionBlockedBySubscription = needsSubscription || isSubscribedButBlocked;
    if (isMobile) {
        return (React.createElement(ThumbIconButton, { type: "comment", statValue: (_d = deviation.stats) === null || _d === void 0 ? void 0 : _d.comments, onClick: actionBlockedBySubscription ? undefined : onClick, biData: biData }));
    }
    return (React.createElement(SubscribeToUnlockTooltip, { deviation: deviation },
        React.createElement(TextButton, { className: classnames(actionBlockedBySubscription && disabledClassName, className), size: "medium", variant: "main", "aria-label": t('deviationview.overlay.a11y.comment'), onClick: actionBlockedBySubscription ? undefined : onClick, disabled: actionBlockedBySubscription, biData: biData },
            React.createElement(CommentOutlineIcon, { className: iconClassName, size: IconSize.MEDIUM, disableDefaultColors: true }),
            React.createElement("span", { className: textClassName }, t('actionbar.comment')))));
};
CommentControl.displayName = 'CommentControl';
export default CommentControl;
//# sourceMappingURL=CommentControl.js.map